var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.banner.banner_type == 31 && _vm.$newAttention)?_c('div',{staticClass:"attention"},[_c('div',[_c('img',{attrs:{"src":_vm.banner.ad_picture,"alt":""}}),_vm._v(" "),_c('button',[_vm._v("关注后，可享受更多服务~")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }